import React from 'react';
import { Modal } from '@mantine/core';
import { ReactComponent as DeleteEventBg } from 'assets/icons/deletefolder.svg';
import { ReactComponent as CloseIcon } from 'assets/icons/crossIcon.svg';
import PrimaryButton from 'components/primaryButton';

import useDeleteSubFolderorFile from '../../hooks/useDeleteSubFolder0rFile';

export default function DeleteSubFolderorFile({
  openModal,
  setOpenModal,
  isDirectory,
  path,
  name,
}) {
  const closeModal = () => {
    setOpenModal(false);
  };

  const deleteFolderMutation = useDeleteSubFolderorFile(closeModal);

  return (
    <Modal
      opened={openModal}
      onClose={setOpenModal}
      overlayColor={'#F8F7F799'}
      overlayBlur={20}
      overlayOpacity={0.5}
      overflow='inside'
      centered
      size={'lg'}
      radius='md'
      transitionDuration={100}
      withCloseButton={false}
      classNames={{
        modal: 'p-0',
        body: 'mt-10 mb-14',
      }}
    >
      <div className='space-y-4 relative'>
        <p className='text-xl leading-7 font-normal text-neutralsBlack text-center'>
          Are you sure you want to <span className='font-bold'>delete</span>
          <br /> the {isDirectory ? 'folder' : 'file'}?
        </p>
        <DeleteEventBg className='w-full my-4' />
        <div className='text-center space-x-7'>
          <button
            className='w-36 border p-1.5 rounded border-primary text-primary'
            onClick={() => {
              deleteFolderMutation.mutate({
                path: `${path}/${name}`,
              });
            }}
          >
            Yes
          </button>
          <button className='w-36' onClick={closeModal}>
            <PrimaryButton>
              <p>No</p>
            </PrimaryButton>
          </button>
        </div>
      </div>

      <CloseIcon
        className='w-12 h-12 absolute top-3 right-3 cursor-pointer'
        onClick={closeModal}
      />
    </Modal>
  );
}
